import React from "react";
import ResetFilterButton from "../buttons/ResetFilterButton";

const FilteredEmptyState = ({ onReset }) => (
  <div className="filtered-empty-state">
    <span className="material-icons-round" aria-hidden="true">search_off</span>
    <h5>Hasil tidak ditemukan</h5>
    <p>Tidak ada data yang cocok dengan filter aktif.</p>
    <ResetFilterButton visible onClick={onReset} />
  </div>
);

export default FilteredEmptyState;
